// axios
import axios from 'axios'

export const subdomains = {
  captain: process.env.VUE_APP_CAPTAIN_ENV,
  cdn: process.env.VUE_APP_CDN_ENV,
  cdnV2: process.env.VUE_APP_CDN_ENV_V2,
  encoder: process.env.VUE_APP_ENCODER_ENV,
  encoderV2: process.env.VUE_APP_ENCODER_ENV_V2,
  storage: process.env.VUE_APP_STORAGE_ENV,
  database: process.env.VUE_APP_DATABASE_ENV,
  snitch: process.env.VUE_APP_SNITCH_ENV,
  porta: process.env.VUE_APP_PORTA_ENV,
  compute: process.env.VUE_APP_COMPUTE_ENV,
  localhost: process.env.VUE_APP_ENV,
  kyubi: process.env.VUE_APP_KYUBI_ENV,
}

export const axiosIns = {}
// eslint-disable-next-line no-restricted-syntax
Object.keys(subdomains).forEach(subdomain => {
  axiosIns[subdomain] = axios.create({
    baseURL: subdomains[subdomain],
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods':
        'GET, POST, PATCH, PUT, DELETE, OPTIONS, HEAD',
      'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
    },
  })
})

const api = sub => axiosIns[sub]

export default api
